import toast from '../../toast'
import {
  keys,
  getKey,
  TypeCheck,
  defineProperty
} from '../core'
import decorator from './decorator'
import icons from '../static/icons'
import HistoryStack from './HistoryStack'
import screen from './screen'
import { addEvent } from './addEvent'
import * as hooks from './hooks'

function insertGlobalTool({ loadingRef }) {

  /** 获取代码提示的信息 */
  const getShowInfo = msg => msg instanceof Error ? msg.message : msg

  let basename = process.env.NODE_ENV === 'development' ? '' : /contextPath=([^;]*)/.exec(document.cookie)?.[1]
  basename === '/' && (basename = '')

  const livecloud = {
    basename:      basename ? `${basename}` : '',
    ...window.livecloud,
    ...TypeCheck,
    ...hooks,
    ...decorator,
    // 请求错误
    REQUEST_ERROR: Symbol(),
    tip:           {
      info:  msg => toast.info(getShowInfo(msg)),
      error: msg => toast.error(getShowInfo(msg)),
      warn:  msg => toast.info(getShowInfo(msg))
    },
    open,
    icons,
    getKey,
    loading: {
      show:  (...args) => loadingRef.current && loadingRef.current.show(...args),
      close: (...args) => loadingRef.current && loadingRef.current.close(...args)
    },
    base64: {
      encode: input => btoa(encodeURIComponent(input)),
      decode: input => decodeURIComponent(atob(input))
    },
    HistoryStack,
    screen,
    addEvent
  }

  defineProperty(window, 'livecloud', livecloud)

  keys(livecloud).forEach(name => {
    defineProperty(livecloud, name, livecloud[name])
  })

}

export {
  insertGlobalTool
}